import React, { useEffect, useState } from 'react'
import { LabelMedium } from 'components/base-ui/FontsV2'
import { Wrapper, QRContainer, ImageQRCode } from './styled'
import { useTranslation } from 'react-i18next'

interface QRCodeSectionProps {
  QRCodeImage: string
  serialNumber: string
}

const QRCodeSection = ({ QRCodeImage, serialNumber }: QRCodeSectionProps) => {
  const [deg, setDeg] = useState(0)
  const { t } = useTranslation()

  useEffect(() => {
    const duration = 2000
    const intervalTime = 16
    const totalSteps = duration / intervalTime
    const stepSize = 360 / totalSteps

    const interval = setInterval(() => {
      setDeg((prev) => {
        if (prev + stepSize >= 360) {
          return 0
        }
        return prev + stepSize
      })
    }, intervalTime)

    return () => clearInterval(interval)
  }, [])

  return (
    <Wrapper>
      <QRContainer $deg={deg}>
        <ImageQRCode $backgroundImage={QRCodeImage} />
      </QRContainer>
      <div>
        <LabelMedium color="baseGrey" data-testid="QRCodeNumber">
          {serialNumber}
        </LabelMedium>
        <LabelMedium>{t('dineIn.couponDetail.qrBenefit')}</LabelMedium>
      </div>
    </Wrapper>
  )
}

export default QRCodeSection
